module.exports = __webpack_public_path__ + "static/media/edit-budget-icon.847799dc.svg";